import React, { useState, useCallback } from 'react';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import FullscreenImageSlider from '../FullscreenImageSlider/FullscreenImageSlider';
import ProductItemImage from '../../Types/ProductItemImage';
import useReady from '../../Hooks/useReady';
import useIsMobile from '../../Hooks/useIsMobile';

interface ProductPageImageGalleryProps {
  images?: ProductItemImage[];
  videoUrl?: string;
}
const ProductPageImageGallery = ({
  images = [],
  videoUrl,
}: ProductPageImageGalleryProps) => {
  const [activeImageIndex, setActiveImageIndex] = useState<
  number | undefined
  >();

  const isMobile = useIsMobile();
  const isReady = useReady();
  const getOrderNumber = useCallback(
    (index) => {
      if (videoUrl) {
        if (index == 0) {
          return 1;
        } else if (index == 1) {
          return 3;
        } else {
          return index + 2;
        }
      } else {
        return index + 1;
      }
    },
    [videoUrl]
  );
  const getClickedIndex = useCallback(
    (index) => {
      if (videoUrl) {
        if (index == 0) {
          return 0;
        } else {
          return index + 1;
        }
      } else {
        return index;
      }
    },
    [videoUrl]
  );
  return (
    <>
      <div className="hidden grid-cols-2 gap-4 lg:grid">
        {isReady && !isMobile && videoUrl && (
          <button
            className="order-2 w-full overflow-hidden rounded bg-gray-100 object-cover will-change-transform aspect-[3/4]"
            onClick={() => setActiveImageIndex(images.length > 0 ? 1 : 0)}
          >
            <video
              className="w-full scale-110 rounded object-cover aspect-[3/4]"
              style={{ clipPath: 'inset(1px 1px)' }}
              src={videoUrl}
              autoPlay
              muted
              playsInline
              loop
            />
          </button>
        )}
        {images &&
          images.map((productImage, idx) => (
            <button
              key={'image' + idx}
              onClick={() => setActiveImageIndex(getClickedIndex(idx))}
              style={{ order: getOrderNumber(idx) }}
              className="group overflow-hidden rounded bg-gray-100 will-change-transform aspect-[3/4]"
            >
              <ResponsiveImage
                pictureProps={{
                  className:
                    'aspect-[3/4] object-cover w-full rounded hover:cursor-pointer transition duration-500 group-hover:scale-105',
                }}
                imgProps={{
                  className:
                    'aspect-[3/4] object-cover w-full rounded hover:cursor-pointer transition duration-500 group-hover:scale-105',
                }}
                {...productImage.imageModel}
              />
            </button>
          ))}
      </div>
      {!isMobile && typeof activeImageIndex != 'undefined' && (
        <FullscreenImageSlider
          images={images}
          videoUrl={videoUrl}
          onClosed={() => setActiveImageIndex(undefined)}
          initialSlide={activeImageIndex}
        />
      )}
    </>
  );
};

export default ProductPageImageGallery;
